import { useState } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import {
  FiMonitor,
  FiServer,
  FiDatabase,
  FiShoppingCart,
  FiCpu,
  FiCloud,
  FiAward,
} from "react-icons/fi";
import { skillCategories } from "../data/skills";
import "./Skills.css";

const iconMap = {
  frontend: FiMonitor,
  backend: FiServer,
  database: FiDatabase,
  cms: FiShoppingCart,
  ai: FiCpu,
  cloud: FiCloud,
  strengths: FiAward,
};

const Skills = () => {
  const [activeCategory, setActiveCategory] = useState(0);
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <section id="skills" className="skills section" ref={ref}>
      <div className="container">
        <motion.div
          className="section__header"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
        >
          <span className="section__label">Skills & Expertise</span>
          <h2 className="section__title">Technologies I Work With</h2>
        </motion.div>

        <div className="skills__tabs">
          {skillCategories.map((cat, i) => {
            const Icon = iconMap[cat.icon] || FiMonitor;
            return (
              <button
                key={i}
                className={`skills__tab ${
                  activeCategory === i ? "skills__tab--active" : ""
                }`}
                onClick={() => setActiveCategory(i)}
              >
                <Icon size={16} />
                {cat.category}
              </button>
            );
          })}
        </div>

        <motion.div
          className="skills__grid"
          key={activeCategory}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          {skillCategories[activeCategory].skills.map((skill, i) => (
            <div key={i} className="skill-item">
              <div className="skill-item__header">
                <span className="skill-item__name">{skill.name}</span>
                <span className="skill-item__level">{skill.level}%</span>
              </div>
              <div className="skill-item__bar">
                <motion.div
                  className="skill-item__fill"
                  initial={{ width: 0 }}
                  animate={inView ? { width: `${skill.level}%` } : { width: 0 }}
                  transition={{ duration: 0.8, delay: i * 0.1 }}
                />
              </div>
            </div>
          ))}
        </motion.div>

        <motion.div
          className="skills__badges"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ delay: 0.5 }}
        >
          {skillCategories.flatMap((cat) =>
            cat.skills.map((s) => s.name)
          ).map((name, i) => (
            <span key={i} className="skills__badge">
              {name}
            </span>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;
